export default __webpack_public_path__ + "static-json/ne_110m_admin_0_boundary_lines_land-ffb01a12ba841efb4bacd827430ca6ed.json";